// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","628":"smootScroll"}[chunkId] || chunkId) + "-" + {"245":"db4b221887ce78c66e15","360":"1e6a7743dd329d691513","628":"5a1cc7e6630cd50e66cd","655":"dd97475aa9c9e5d02662"}[chunkId] + ".js";
};